import { space, mediaQueries } from 'style/config';

const SM_COL_GAP = space[4] / 2;
const LG_COL_GAP = space[5] / 2;
const SM_ROW_GAP = space[5] / 2;
const LG_ROW_GAP = space[7] / 2;

const BANNER_MIN_HEIGHT_BASE = 80;
const BANNER_MIN_HEIGHT_SM = 90;

const getStyles = () => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: -SM_ROW_GAP,
        marginBottom: -SM_ROW_GAP,
        marginLeft: -SM_COL_GAP,
        marginRight: -SM_COL_GAP,
        [mediaQueries.sm]: {
            marginTop: -LG_ROW_GAP,
            marginBottom: -LG_ROW_GAP,
            marginLeft: -LG_COL_GAP,
            marginRight: -LG_COL_GAP
        },
        '@media (min-width: 768px)': {
            padding: `${space[5]}px ${space[4]}px`
        }
    },
    item: {
        display: 'flex',
        width: '50%',
        paddingTop: SM_ROW_GAP,
        paddingBottom: SM_ROW_GAP,
        paddingLeft: '1px',
        paddingRight: '1px',

        ['@media (min-width: 556px)']: {
            width: 'calc(1 / 3 * 100%)'
        },
        [mediaQueries.sm]: {
            paddingTop: LG_ROW_GAP,
            paddingBottom: `${space[7]}px`,
            paddingLeft: LG_COL_GAP,
            paddingRight: LG_COL_GAP,
            padding: `${space[4]}px`
        },
        [mediaQueries.lg]: {
            width: 'calc(1 / 3 * 100%)'
        }
    },
    banner: {
        width: '100%',
        height: 'auto',
        minHeight: BANNER_MIN_HEIGHT_BASE,
        paddingTop: space[1],
        paddingBottom: space[1],
        paddingLeft: SM_COL_GAP,
        paddingRight: SM_COL_GAP,
        [mediaQueries.sm]: {
            minHeight: BANNER_MIN_HEIGHT_SM,
            paddingTop: space[2],
            paddingBottom: space[2],
            paddingLeft: LG_COL_GAP,
            paddingRight: LG_COL_GAP
        }
    },
    itemLazy: {
        minHeight: space[9] + space[9] + space[9] + space[3], // 96 + 96 + 96 + 12 = 300
        [mediaQueries.sm]: {
            minHeight: space[9] + space[9] + space[9] + space[7] + space[5] // 96 + 96 + 96 + 48 + 24 = 360
        }
    },
    showMore: {
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        flex: 1,
        order: 9999
    },
    showMoreButton: {
        width: '100%',
        maxWidth: '16.5em'
    },
    productListContainer: {
        width: '100vw'
    },
    // Dedicated full-width row for the Related Searches section. Mirrors `banner` (width:100%).
    // NOT `item` (re-asserts calc(1/3*100%) on LGUI) and NOT `productListContainer` (100vw overflow).
    relatedSearchesRow: {
        flexBasis: '100%',
        width: '100%'
    },
    zeroResults: { flexDirection: 'column', margin: 0 }
});

export default getStyles;
